import { ApiClient } from './client.js'
import { PLAYLISTS } from './resources.js'

const client = new ApiClient()

export default {
  retrieve (playlistId) {
    return client.get(`${PLAYLISTS}${playlistId}/`)
  },

  list () {
    return client.get(`${PLAYLISTS}`)
  },

  listAll () {
    return client.getAll(`${PLAYLISTS}`)
  }
}
